import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiService } from "../../../utils/api";

function ScannerImage() {
  const [file, setFile] = useState(null);
  const [title, setTitle] = useState("");
  const [scanning, setScanning] = useState(false);
  const [error, setError] = useState("");
  const [content, setContent] = useState("");
  const [imgSrc, setImgSrc] = useState("");
  const [minutes, setMinutes] = useState(1);
  const navigate = useNavigate();

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      if (!title) {
        setTitle(selectedFile.name.split(".")[0]);
      }

      // Create a preview for the image
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setImgSrc(reader.result);
      });
      reader.readAsDataURL(selectedFile);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      setError("Please select a file to scan");
      return;
    }

    if (!minutes) {
      setError("PLese sleelct minute");
      return;
    }

    setScanning(true);
    setError("");

    try {
      const fileToUpload = file;
      console.log("Using image:", fileToUpload);

      const formData = new FormData();
      formData.append("document", fileToUpload);
      formData.append("title", title);
      formData.append("minutes", minutes);
      formData.append("content", content);

      // Log the form data to verify what's being sent
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }

      const response = await apiService.scanImageDocument(formData);
      const data = response.data;

      if (data.success) {
        navigate(`/dashboard/teacher/documents-image/${data.document.id}`);
      } else {
        setError(data.message || "Failed to upload document");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Error Uploading document");
      console.error(err);
    } finally {
      setScanning(false);
    }
  };

  // Check if current user is a teacher
  const isTeacher = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    return user && user.role === "teacher";
  };

  return (
    <div className="scanner-container">
      <h2>Upload Image Document</h2>

      <form onSubmit={handleSubmit} className="upload-form">
        <div className="form-group">
          <label>Document Title:</label>
          <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Enter document title" required />
        </div>

        <div className="form-group">
          <label>Minutes:</label>
          <input type="number" value={minutes} onChange={(e) => setMinutes(Math.max(1, parseInt(e.target.value) || 1))} min="1" required />
        </div>

        <div className="form-group">
          <label>Documment Content:</label>
          <textarea value={content} onChange={(e) => setContent(e.target.value)} placeholder="Enter document content" required rows="6" />
        </div>

        <div className="file-input-container">
          <input type="file" onChange={handleFileChange} accept="image/*" id="file-upload" className="file-input" />
          <label htmlFor="file-upload" className="file-label">
            {file ? file.name : "Choose a file"}
          </label>
        </div>

        {imgSrc && (
          <div className="image-preview">
            <h4>Preview:</h4>
            <img src={imgSrc} alt="Document preview" style={{ maxWidth: "100%", maxHeight: "300px" }} />
          </div>
        )}

        {error && <p className="error-message">{error}</p>}

        <div className="button-group">
          <button type="button" onClick={() => navigate("/dashboard/teacher")} className="cancel-button">
            Cancel
          </button>
          <button type="submit" className="scan-button" disabled={!file || scanning || !isTeacher()}>
            {scanning ? "Uploading..." : "Upload Document"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default ScannerImage;
